<p>vendor-footer works!</p>
